import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Prism from 'prismjs';
import { SharedService } from 'src/app/shared/shared.service';

import { AbstractListComponent } from '../../../../model/AbstractListComponent';
import { AulaDTO, ListAuleDTO, SelectDTO } from './../../../../model/newModel';
import { AAulaService } from './../a-aula.service';

@Component({
  selector: 'app-list-aule',
  templateUrl: './list-aule.component.html',
  styleUrls: ['./list-aule.component.css'],
})
export class ListAuleComponent
  extends AbstractListComponent
  implements AfterViewInit, OnInit {
  listAule: ListAuleDTO;
  tipologieAbilitatoDisabilitato: SelectDTO[];
  abilitatoDisabilitato: string;
  tempListAule: AulaDTO[];
  showAule: boolean;

  ngOnInit(): void {
    this.tipologieAbilitatoDisabilitato = this.sharedService.allSelectTipologieAbilitatoDisabilitato();
    super.ngOnInit();
    this.getListAule();
  }

  getListAule() {
    this.spinner.show();
    this.aAulaService.search(this.abilitatoDisabilitato).subscribe(
      (result) => {
        this.listAule = result;
        this.calcolaListVaiA(this.listAule.pages);
        this.idVaiA = '' + (this.listAule.currentPage - 1);
        if (this.listAule.aule.length > 0) {
          this.showAule = true;
        } else {
          this.showAule = false;
        }
        this.tempListAule = Object.assign([], this.listAule.aule);
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore search');
        this.spinner.hide();
      }
    );
  }

  goToAulaEditDetail(idAula: number) {
    this.router.navigate(['/a-aula/modifica'], {
      queryParams: { idAula },
    });
  }

  disabilita(id: number) {
    this.aAulaService.abilitaDisabilita(id, false).subscribe((result) => {
      if (result) {
        this.sharedService.openOkModal();
        this.modalSubscribe = this.ngxSmartModalService
          .getModal('okModal')
          .onClose.subscribe((modal: NgxSmartModalComponent) => {
            this.getListAule();
          });
      }
    });
  }

  disabilitaAbilita(id: number, value: boolean) {
    if (value) {
      this.disabilita(id);
    } else {
      this.abilita(id);
    }
  }

  abilita(id: number) {
    this.aAulaService.abilitaDisabilita(id, true).subscribe((result) => {
      if (result) {
        this.sharedService.openOkModal();
        this.modalSubscribe = this.ngxSmartModalService
          .getModal('okModal')
          .onClose.subscribe((modal: NgxSmartModalComponent) => {
            this.getListAule();
          });
      }
    });
  }

  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private aAulaService: AAulaService
  ) {
    super();
  }

  nextPage(skip: number, take: number, count: number) {
    this.spinner.show();
    this.aAulaService
      .nextPage(this.abilitatoDisabilitato, skip, take, count)
      .subscribe(
        (result) => {
          this.listAule = result;
          this.calcolaListVaiA(this.listAule.pages);
          this.idVaiA = '' + (this.listAule.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search next');
          this.spinner.hide();
        }
      );
  }

  goToPage(idVaiA: string, event: any) {
    this.spinner.show();
    this.aAulaService
      .goToPage(this.abilitatoDisabilitato, idVaiA, this.listAule.take)
      .subscribe(
        (result) => {
          this.listAule = result;
          this.calcolaListVaiA(this.listAule.pages);
          this.idVaiA = '' + (this.listAule.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search goToPage');
          this.spinner.hide();
        }
      );
  }

  previousPage(skip: number, take: number) {
    this.spinner.show();
    this.aAulaService
      .previousPage(this.abilitatoDisabilitato, skip, take)
      .subscribe(
        (result) => {
          this.listAule = result;
          this.calcolaListVaiA(this.listAule.pages);
          this.idVaiA = '' + (this.listAule.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search previous');
          this.spinner.hide();
        }
      );
  }
}
